import { useCallback, useState } from 'react'
import { Toast } from 'pages/games/pinmonkey/editor/toast'

// Collapses the show-a-dismissible-error-toast boilerplate that was
// independently copy-pasted across wall/main.js, home/main.js, and
// pinmonkey/editor/main.js: state + setState(null) + <Toast .../>.
export const useToast = (kind = 'error') => {
  const [message, setMessage] = useState(null)

  const dismissToast = useCallback(() => setMessage(null), [])

  const toastElement = (
    <Toast message={message} kind={kind} onDismiss={dismissToast} />
  )

  return { toastMessage: message, showToast: setMessage, dismissToast, toastElement }
}
